var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seckill_main"},[_c('will-learn',{attrs:{"layout":"verticalLayout"}}),_c('open-rob',{attrs:{"robTime":19}}),_c('open-rob',{attrs:{"robTime":22}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }